module.exports = __webpack_public_path__ + "static/media/FE_logo_W.014aeac5.png";